export default {
  from: {
    id: 'from',
    defaultMessage: 'From',
  },
}
